/**
 * changePasswordConstants
 *
 * @package                onboard
 * @subpackage             changePasswordConstants
 * @category               Constants
 * @DateOfCreation         15 May 2019
 * @ShortDescription       This is responsible for Change Password action names
 */
export const changePasswordConstants = {
    PASSWORD_REQUEST  : 'PASSWORD_REQUEST',
    PASSWORD_SUCCESS  : 'PASSWORD_SUCCESS',
    PASSWORD_FAILURE  : 'PASSWORD_FAILURE',
    PASSWORD_RESET 	  : 'PASSWORD_RESET'
};
